<template>
  <el-form ref="form" :model="form" label-width="100px">
    <input type="hidden" v-model="form.id" />
    <el-form-item label="标题">
      <el-input v-model="form.name"></el-input>
    </el-form-item>
    <el-form-item label="所属分类">
      <el-select v-model="form.type"  placeholder="请选择">
        <el-option
            v-for="item in cateList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="onSubmit">保存</el-button>
      <el-button @click="handleClose">重置</el-button>
    </el-form-item>
  </el-form>

</template>

<script>
import axios from "axios";

export default {
  name: "getTypeView",
  data(){
    return{

      form: {
        id: "",
        cate_id: "",
        b_title: "",
        b_name: "",
        b_info: "",
        top: 0,
        status: 0,
        b_img: "",
        b_mobimg: "",
        b_url: "",
        fileList:[],
        fileListmob:[],
        imgsrc:""
      },
      options: [{
        value: 0,
        label: '未审核'
      }, {
        value: 1,
        label: '正常'
      }],
      cateList:[
        {label:'Air compressor Types',value:"type"},
        {label:'Lubrication Way',value:"way"}
      ],
    }
  },
  // created() {
  //   this.getCategory();
  // },
  mounted() {
    let geturl = window.location.href;
    let geturlinfo = geturl.split('?')[1];
    let getqys = new URLSearchParams('?'+geturlinfo);
    let id = getqys.get('id');
    if(id > 0){
      axios.get('/api/Type/getType.html?id='+id).then((res)=>{
        if(res.data.code == 200){
          this.form = res.data.data;
        }
      });
    }
  },
  methods:{
    getCategory() {    },
    resetData(){
      this.form = this.$options.data().form;
    },

    onSubmit() {
      axios({
        method:'post',
        url:'/api/Type/setType.html',
        data:this.form
      }).then((res)=>{
        if(res.data.code != 200) {

          alert(res.data.msg);
        }
        else{
          alert(res.data.msg);
          // this.$props.id = res.data.id;
          // this.form.id = res.data.id;
          this.$router.go(0);
        }
      })
    },
  }
}
</script>

<style scoped>

</style>